export const isTestCafeEnabled = (): boolean =>
  import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL &&
  sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG'

export const isTestCafeAuthEnabled = (): boolean =>
  import.meta.env.VITE_APP_API_BASE_AUTH_TESTCAFE_URL &&
  sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG'

export default { isTestCafeEnabled, isTestCafeAuthEnabled }
